/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiResponseBoolean } from '../models/api-response-boolean';
import { ApiResponseLong } from '../models/api-response-long';
import { ApiResponseMapStringString } from '../models/api-response-map-string-string';
import { ApiResponseSignupSurvey } from '../models/api-response-signup-survey';
import { ApiResponseSocialProfile } from '../models/api-response-social-profile';
import { ApiResponseString } from '../models/api-response-string';
import { getSignUpGeo } from '../fn/sign-up-api/get-sign-up-geo';
import { GetSignUpGeo$Params } from '../fn/sign-up-api/get-sign-up-geo';
import { isCompanyNameAvailable } from '../fn/sign-up-api/is-company-name-available';
import { IsCompanyNameAvailable$Params } from '../fn/sign-up-api/is-company-name-available';
import { sendOtpSignUp } from '../fn/sign-up-api/send-otp-sign-up';
import { SendOtpSignUp$Params } from '../fn/sign-up-api/send-otp-sign-up';
import { signUp } from '../fn/sign-up-api/sign-up';
import { SignUp$Params } from '../fn/sign-up-api/sign-up';
import { submitSignUpSurvey } from '../fn/sign-up-api/submit-sign-up-survey';
import { SubmitSignUpSurvey$Params } from '../fn/sign-up-api/submit-sign-up-survey';
import { verifyOtpSignUp } from '../fn/sign-up-api/verify-otp-sign-up';
import { VerifyOtpSignUp$Params } from '../fn/sign-up-api/verify-otp-sign-up';
import { verifySocialSignUp } from '../fn/sign-up-api/verify-social-sign-up';
import { VerifySocialSignUp$Params } from '../fn/sign-up-api/verify-social-sign-up';

@Injectable({ providedIn: 'root' })
export class SignUpApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `signUp()` */
  static readonly SignUpPath = '/v1/api/ui/public/sign-up';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `signUp()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  signUp$Response(params: SignUp$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseString>> {
    return signUp(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `signUp$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  signUp(params: SignUp$Params, context?: HttpContext): Observable<ApiResponseString> {
    return this.signUp$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseString>): ApiResponseString => r.body)
    );
  }

  /** Path part for operation `submitSignUpSurvey()` */
  static readonly SubmitSignUpSurveyPath = '/v1/api/ui/public/sign-up/survey/{reference}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `submitSignUpSurvey()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  submitSignUpSurvey$Response(params: SubmitSignUpSurvey$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseSignupSurvey>> {
    return submitSignUpSurvey(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `submitSignUpSurvey$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  submitSignUpSurvey(params: SubmitSignUpSurvey$Params, context?: HttpContext): Observable<ApiResponseSignupSurvey> {
    return this.submitSignUpSurvey$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseSignupSurvey>): ApiResponseSignupSurvey => r.body)
    );
  }

  /** Path part for operation `verifySocialSignUp()` */
  static readonly VerifySocialSignUpPath = '/v1/api/ui/public/sign-up/social/verify';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `verifySocialSignUp()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  verifySocialSignUp$Response(params: VerifySocialSignUp$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseSocialProfile>> {
    return verifySocialSignUp(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `verifySocialSignUp$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  verifySocialSignUp(params: VerifySocialSignUp$Params, context?: HttpContext): Observable<ApiResponseSocialProfile> {
    return this.verifySocialSignUp$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseSocialProfile>): ApiResponseSocialProfile => r.body)
    );
  }

  /** Path part for operation `verifyOtpSignUp()` */
  static readonly VerifyOtpSignUpPath = '/v1/api/ui/public/sign-up/otp/verify';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `verifyOtpSignUp()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  verifyOtpSignUp$Response(params: VerifyOtpSignUp$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseLong>> {
    return verifyOtpSignUp(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `verifyOtpSignUp$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  verifyOtpSignUp(params: VerifyOtpSignUp$Params, context?: HttpContext): Observable<ApiResponseLong> {
    return this.verifyOtpSignUp$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseLong>): ApiResponseLong => r.body)
    );
  }

  /** Path part for operation `sendOtpSignUp()` */
  static readonly SendOtpSignUpPath = '/v1/api/ui/public/sign-up/otp/send';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sendOtpSignUp()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  sendOtpSignUp$Response(params: SendOtpSignUp$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseLong>> {
    return sendOtpSignUp(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `sendOtpSignUp$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  sendOtpSignUp(params: SendOtpSignUp$Params, context?: HttpContext): Observable<ApiResponseLong> {
    return this.sendOtpSignUp$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseLong>): ApiResponseLong => r.body)
    );
  }

  /** Path part for operation `getSignUpGeo()` */
  static readonly GetSignUpGeoPath = '/v1/api/ui/public/sign-up/geo';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSignUpGeo()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSignUpGeo$Response(params?: GetSignUpGeo$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseMapStringString>> {
    return getSignUpGeo(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSignUpGeo$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSignUpGeo(params?: GetSignUpGeo$Params, context?: HttpContext): Observable<ApiResponseMapStringString> {
    return this.getSignUpGeo$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseMapStringString>): ApiResponseMapStringString => r.body)
    );
  }

  /** Path part for operation `isCompanyNameAvailable()` */
  static readonly IsCompanyNameAvailablePath = '/v1/api/ui/public/sign-up/company-available';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `isCompanyNameAvailable()` instead.
   *
   * This method doesn't expect any request body.
   */
  isCompanyNameAvailable$Response(params: IsCompanyNameAvailable$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseBoolean>> {
    return isCompanyNameAvailable(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `isCompanyNameAvailable$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  isCompanyNameAvailable(params: IsCompanyNameAvailable$Params, context?: HttpContext): Observable<ApiResponseBoolean> {
    return this.isCompanyNameAvailable$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseBoolean>): ApiResponseBoolean => r.body)
    );
  }

}
